import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "article"
};
const _hoisted_2 = {
  class: "article-body"
};
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"top-decor\"><div class=\"decor-left\"></div><div class=\"decor-right\"></div></div><div class=\"background\"><div class=\"background-top\"></div></div>", 2);
const _hoisted_5 = {
  class: "article-content"
};
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "article-content-top"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "top-fill"
}), /*#__PURE__*/_createElementVNode("div", {
  class: "corner"
})], -1);
const _hoisted_7 = {
  class: "article-content-body"
};
const _hoisted_8 = ["innerHTML"];
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  class: "article-content-bottom"
}, null, -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: "hero",
    style: _normalizeStyle({
      backgroundImage: `url(${$options.bgImage})`
    })
  }, null, 4), _createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", _hoisted_7, [_createElementVNode("h4", null, _toDisplayString($data.article.Title), 1), _createElementVNode("div", {
    innerHTML: $data.article.Body
  }, null, 8, _hoisted_8)]), _hoisted_9])])]);
}